import React from "react";
import { TableContentForMasterCardLeafCollection } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const total = this.props.total;

        return (
            <div>
                <h3><center><u>Master Card Leaf Collection Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>Collection Type: </b> {searchData.collectionType === undefined ? "All Collection Types"
                        : searchData.collectionType}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Current Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="masterCardLeafCollectionPdfTable">
                                <thead>
                                    <tr>
                                        <th rowSpan="2">Date</th>
                                        <th rowSpan="2">Route name</th>
                                        <th rowSpan="2">Collection Type Name</th>
                                        <th rowSpan="2">Master card number</th>
                                        <th rowSpan="2">Net (Kg)</th>
                                        <th colSpan="2">Supplier</th>
                                    </tr>
                                    <tr>
                                        <th>Registration Number</th>
                                        <th>Narration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForMasterCardLeafCollection
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan="4">Total</th>
                                        <th>{total.totalNetWeight.toFixed(2)}</th>
                                        <th colSpan="2"></th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}